"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lighten = exports.darken = exports.fade = exports.emphasize = exports.getLuminance = exports.getContrastRatio = exports.recomposeColor = exports.decomposeColor = exports.rgbToHex = exports.convertHexToRGB = exports.hexToRgb = void 0;
var colorManipulator_1 = __importDefault(require("@material-ui/core/styles/colorManipulator"));
var styles_1 = require("@material-ui/core/styles");
/** @deprecated Will be removed in a future major release; import color manipulation functions directly from beam/dist/styles */
var colorManipulator = colorManipulator_1.default;
exports.default = colorManipulator;
/** @deprecated import hexToRgb directly from beam/dist/styles */
exports.hexToRgb = styles_1.hexToRgb;
/** @deprecated import convertHexToRGB directly from beam/dist/styles */
exports.convertHexToRGB = styles_1.hexToRgb;
/** @deprecated import rgbToHex directly from beam/dist/styles */
exports.rgbToHex = styles_1.rgbToHex;
/** @deprecated import decomposeColor directly from beam/dist/styles */
exports.decomposeColor = styles_1.decomposeColor;
/** @deprecated import recomposeColor directly from beam/dist/styles */
exports.recomposeColor = styles_1.recomposeColor;
/** @deprecated import getContrastRatio directly from beam/dist/styles */
exports.getContrastRatio = styles_1.getContrastRatio;
/** @deprecated import getLuminance directly from beam/dist/styles */
exports.getLuminance = styles_1.getLuminance;
/** @deprecated import emphasize directly from beam/dist/styles */
exports.emphasize = styles_1.emphasize;
/** @deprecated fade has been renamed to alpha; import alpha directly from beam/dist/styles */
exports.fade = styles_1.fade;
/** @deprecated import darken directly from beam/dist/styles */
exports.darken = styles_1.darken;
/** @deprecated import lighten directly from beam/dist/styles */
exports.lighten = styles_1.lighten;
//# sourceMappingURL=colorManipulator.js.map